import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", dark = false }) {
  return (
    <Link to="/" className={`inline-flex items-center gap-2 ${className}`} data-testid="site-logo">
      <span className="grid h-9 w-9 place-items-center rounded-lg bg-brand font-display text-lg font-800 font-bold text-brand-foreground shadow-soft">
        K
      </span>
      <span className={`font-display text-2xl font-extrabold tracking-tight ${dark ? "text-white" : "text-ink"}`}>
        KHA
      </span>
    </Link>
  );
}
